<template>
  <div class="components-container">
    <header>
      <span class="title">减购</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(46)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @row-click="rowClick">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
      <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
      <el-table-column prop='phone' label='联系电话' min-width='140'></el-table-column>
      <el-table-column prop='version_name' label='减购项目' min-width='140'>
        <template slot-scope="scope">{{redfieldInit(scope.row.type)}}</template>
      </el-table-column>
      <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
      <el-table-column label='创建时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n1" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <reduction-detail v-if="dialogDetail" :reduction="reductionDtl"></reduction-detail>
    </transition>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <reduction-add v-if="dialogAdd" :reduction="{}"></reduction-add>
    </transition>
  </div>
</template>
<script>
import reductionDetail from '@/page/business/reduction-detail'// 减购详情
import reductionAdd from '@/page/business/reduction-add'// 减购
import {HTTPServer} from '@/common/js/ajax.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>减购</b>',
      searchInput: '',
      tableList: [],
      moduleId: 4,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogDetail: false,
      reductionDtl: {},
      dialogAdd: false
    }
  },
  components: {
    reductionDetail,
    reductionAdd
  },
  mixins: [mixin],
  mounted () {
    this.queryReductionList()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    /** 减购 - 更新列表 */
    this.$bus.off('query-reduction-list')
    this.$bus.on('query-reduction-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum = 1
        }
        this.queryReductionList()
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogAdd = false
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddDetailModal', (value) => {
      if (value) {
        this.dialogDetail = false
      }
    })
  },
  methods: {
    /** 获取减购 */
    queryReductionList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryReductionList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryReductionList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryReductionList()
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryReductionList()
    },
    /** 新增减购弹窗 */
    AddDialog () {
      this.dialogAdd = true
    },
    /** 进入减购详情 */
    rowClick (row, event, column) {
      this.reductionDtl = row
      this.dialogDetail = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/reduction.vue